export { getViewTopicRoute } from './routes';
